<template>
  <div>

    <v-dialog v-model="dialog" persistent width="600" scrollable>

      <form @submit.prevent="save">

        <v-card :loading="btnLoading">

          <v-card-title>
            {{ title }}
            <v-spacer/>
            <v-btn icon @click="close">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider/>

          <v-card-text class="pa-8">

            <v-alert
                text
                border="left"
                dense
                color="info"
                class="mb-8"
            >
              <div v-if="type === 'target'">

                <strong>
                  Import de nouveaux utilisateurs avec objectifs
                </strong>

                <p class="mb-2 mt-2">
                  Le fichier Excel doit contenir les colonnes suivantes :
                </p>

                <v-chip small color="info" class="mr-1">
                  Colonne 1 : Téléphone
                </v-chip>

                <v-chip small color="info" class="mr-1">
                  Colonne 2 : Objectif
                </v-chip>

                <div class="mt-4">

                  <v-btn
                      small
                      depressed
                      color="info"
                      :href="FILE_URL+'/import_targets.xlsx'"
                      target="_blank"
                  >
                    <v-icon left small>
                      mdi-download
                    </v-icon>

                    Télécharger un exemple Excel
                  </v-btn>

                </div>

              </div>

              <div v-else>

                <strong>
                  Mise à jour des performances utilisateurs
                </strong>

                <p class="mb-2 mt-2">
                  Le fichier Excel doit contenir les colonnes suivantes :
                </p>

                <v-chip small color="info" class="mr-1">
                  Colonne 1 : Téléphone
                </v-chip>

                <v-chip small color="info" class="mr-1">
                  Colonne 2 : Réalisé
                </v-chip>

                <div class="mt-4">

                  <v-btn
                      small
                      depressed
                      color="info"
                      :href="FILE_URL+'/import_achieved.xlsx'"
                      target="_blank"
                  >
                    <v-icon left small>
                      mdi-download
                    </v-icon>

                    Télécharger un exemple Excel
                  </v-btn>

                </div>

              </div>
            </v-alert>

            <v-select class="mb-3"
                      v-model="form.objective_id"
                      :items="objectives"
                      item-text="name.fr"
                      item-value="id"
                      label="Choisir un objectif *"
                      outlined
                      dense
                      persistent-hint
                      hint="Sélectionnez l’objectif à attribuer aux utilisateurs importés."
                      prepend-inner-icon="mdi-bullseye-arrow"
                      :error-messages="errors.objective_id"
            />

            <v-file-input
                v-model="form.file"
                label="Fichier Excel"
                accept=".xlsx,.xls,.csv"
                outlined
                dense
                persistent-hint
                hint="Formats acceptés : Excel (.xlsx, .xls). Le fichier doit contenir les colonnes requises."
                prepend-inner-icon="mdi-file-excel"
                show-size
                truncate-length="25"
                :error-messages="errors.file"
            />


          </v-card-text>

          <v-divider/>

          <v-card-actions>
            <v-spacer/>
            <v-btn
                depressed
                color="success"
                :loading="btnLoading"
                type="submit"
            >
              <v-icon left>
                mdi-import
              </v-icon>

              Importer
            </v-btn>

          </v-card-actions>

        </v-card>

      </form>

    </v-dialog>

  </div>
</template>

<script>
import {HTTP} from "@/http-common";

export default {
  props: ['objectives'],

  data() {
    return {
      dialog: false,
      btnLoading: false,
      errors: {},
      FILE_URL: process.env.VUE_APP_FILE_URL,

      type: 'target',

      form: {
        file: null,
        objective_id: null,
      }
    };
  },
  computed: {
    title() {
      return this.type === 'target'
          ? 'Importer des utilisateurs'
          : 'Mise à jour des réalisés';
    }
  },

  methods: {
    open(type = 'target') {
      this.type = type;
      this.dialog = true;
      this.errors = {};
      this.form.file = null;
    },

    close() {
      this.dialog = false;
    },

    save() {
      this.btnLoading = true;
      this.errors = {};

      const formData = new FormData();
      formData.append('file', this.form.file ?? '');
      formData.append('objective_id', this.form.objective_id ?? '');
      formData.append('type', this.type ?? '');

      HTTP.post(`/v1/opus/objectives/import`, formData)
          .then(() => {
            this.$emit("refresh");
            this.$successMessage = "Import effectué avec succès.";
            this.close();
          })
          .catch(err => {
            this.errors = err.response?.data?.errors || {};
          })
          .finally(() => {
            this.btnLoading = false;
          });
    }
  }
};
</script>